import { memo } from 'react';
import type { SVGProps, FC } from 'react';

type IconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const IconArrowRight: FC<IconProps> = memo(
  ({ color = '#007383', ...props }) => (
    <svg
      className="icon-arrow-right"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_28_7750)">
        <path
          d="M21.2389 12.7495L12.2389 7.76953V11.6245H3.25391V13.8745H12.2389V17.7295L21.2389 12.7495Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_28_7750">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.238281 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  )
);

IconArrowRight.displayName = 'IconArrowRight';
